module.exports = __webpack_public_path__ + "img/floppy-disk.ba9821cc.png";